/**
 * SS PDP product details — <ss-pdp-product-details>
 * Mobile accordion (optionally one open at a time) and desktop tabs with
 * roving keyboard focus. Both layouts share the same content; CSS shows one.
 */
(function () {
  'use strict';
  if (customElements.get('ss-pdp-product-details')) return;

  class SsPdpProductDetails extends HTMLElement {
    constructor() { super(); this._listeners = []; }

    connectedCallback() {
      this.singleOpen = this.dataset.singleOpen === 'true';
      this.querySelectorAll('[data-ss-toggle]').forEach(function (button) {
        this.on(button, 'click', function () { this.toggle(button); }.bind(this));
      }, this);
      this.tabs = Array.from(this.querySelectorAll('[data-ss-tab]'));
      this.tabs.forEach(function (tab, i) {
        this.on(tab, 'click', function () { this.selectTab(i); }.bind(this));
        this.on(tab, 'keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (i - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next === null) return;
          event.preventDefault();
          this.selectTab(next);
          this.tabs[next].focus();
        }.bind(this));
      }, this);
    }

    disconnectedCallback() {
      this._listeners.forEach(function (l) { l[0].removeEventListener(l[1], l[2]); });
      this._listeners = [];
    }

    on(el, type, fn) { el.addEventListener(type, fn); this._listeners.push([el, type, fn]); }

    toggle(button) {
      var item = button.closest('[data-ss-item]');
      var panel = document.getElementById(button.getAttribute('aria-controls'));
      if (!item || !panel) return;
      var open = !item.classList.contains('is-open');
      if (open && this.singleOpen) {
        this.querySelectorAll('[data-ss-item].is-open').forEach(function (other) {
          other.classList.remove('is-open');
          var b = other.querySelector('[data-ss-toggle]');
          var p = b && document.getElementById(b.getAttribute('aria-controls'));
          if (b) b.setAttribute('aria-expanded', 'false');
          if (p) p.hidden = true;
        });
      }
      item.classList.toggle('is-open', open);
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
      panel.hidden = !open;
    }

    selectTab(index) {
      this.tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
        var panel = document.getElementById(tab.getAttribute('aria-controls'));
        if (panel) { panel.classList.toggle('active', active); panel.hidden = !active; }
      });
    }
  }

  customElements.define('ss-pdp-product-details', SsPdpProductDetails);
})();
